export default "__VITE_ASSET__B5Mv2tU___"